/* eslint-disable no-restricted-properties */
import { wipeStorage } from '../shared/functions';

let token = localStorage.token;
let tenant = localStorage.tenant;
export const watchTokenChange = () => {
  window.addEventListener(
    'storage',
    () => {
      // Token
      if (token && localStorage.token !== token) {
        window.location.reload();
      }
      token = localStorage.token;
      // Tenant
      if (tenant && localStorage.tenant !== tenant) {
        wipeStorage();
      }
      tenant = localStorage.tenant;
    },
    false,
  );
};
